import React, {Component} from 'react';
import {BootstrapTable, TableHeaderColumn} from "react-bootstrap-table";
import tabgrid from "../../../../utilities/TabGrid";
import KonfiguracjaWartoscKomorka from "./KonfiguracjaWartoscKomorka";

export default class KonfiguracjaTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            edytowanyObiekt: null
        };
        this.renderWartosc = this.renderWartosc.bind(this)
    }

    renderWartosc(cell, row) {
        let czyEdycja = (Boolean(this.state.edytowanyObiekt) ? (this.state.edytowanyObiekt.sekcja === row.sekcja && this.state.edytowanyObiekt.pozycja === row.pozycja) : false)
        let czyMoznaEdytowac = !Boolean(this.state.edytowanyObiekt)
        if (czyEdycja) {

            return <KonfiguracjaWartoscKomorka
                obiekt={row}
                wartosc={cell}
                handleClickZapisz={(obj) => {
                    this.props.handleClickZapisz(obj);
                    this.setState({edytowanyObiekt: null})
                }}
                handleClickAnuluj={() => this.setState({edytowanyObiekt: null})}
            />

        } else {
            return (
                <div>
                    {
                        (row.sekcja === 'Status-kolor') &&
                        <span style={{
                            background: Boolean(row.wartosc) ? row.wartosc : '#fff',
                            display: 'inline-block',
                            width: '16px',
                            height: '16px',
                            border: '1px solid #999',
                            borderRadius: '2px',
                            marginRight: '10px',
                            lineHeight: '1em'
                        }}></span>
                    }
                    {row.wartosc}
                    {
                        czyMoznaEdytowac &&
                        <i className={'fa fa-pencil'}
                           title={'Edytuj wartość'}
                           onClick={() => {
                               this.setState({edytowanyObiekt: row});
                           }}
                           style={{marginLeft: '8px', cursor: 'pointer'}}
                        ></i>
                    }
                </div>
            )
        }
    }

    render() {

        const options = {
            sizePerPage: 15,  // Showing 30 for the size per page as default
            sizePerPageList: [10, 15, 30],
            noDataText: 'Brak pasujących rekordów',

        };
        return (
            <div>
                <BootstrapTable data={this.props.data}
                                options={options}
                                pagination
                                hover
                >
                    <TableHeaderColumn dataField='id' isKey thStyle={tabgrid.tg4} tdStyle={tabgrid.tg4} dataSort
                                       filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                    >ID</TableHeaderColumn>

                    <TableHeaderColumn dataField='sekcja' dataSort
                                       thStyle={tabgrid.tg7} tdStyle={tabgrid.tg7}
                                       filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                    >Sekcja</TableHeaderColumn>
                    <TableHeaderColumn dataField='pozycja' dataSort
                                       thStyle={tabgrid.tg7} tdStyle={tabgrid.tg7}
                                       filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                    >Pozycja</TableHeaderColumn>
                    <TableHeaderColumn dataField='wartosc' dataSort
                                       thStyle={tabgrid.tg7} tdStyle={tabgrid.tg7}
                                       filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                       dataFormat={this.renderWartosc}
                    >Wartość</TableHeaderColumn>
                </BootstrapTable>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/administracja/konfiguracja/components/KonfiguracjaTable.js